<template>
  <div
    class="flex items-center"
    :style="{
      height: '17px',
      'flex-grow': '1',
      overflow: 'hidden',
    }"
  >
    <Skeleton width="60%" height="1rem" />
  </div>
</template>

<script>
import { Skeleton } from "primevue";
export default {
  name: "TableSkeleton",
  components: {
    Skeleton,
  },
};
</script>

<style></style>
